<template lang="pug">
  .post-heading(v-if="heading || subHeading")
    h2.title(v-if="heading") {{ heading }}
    h3.subtitle(v-if="subHeading") {{ subHeading }}
</template>

<script>
export default {
    name: 'Heading',
    props: {
        heading: {
            type: String
        },
        subHeading: {
            type: String
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.post-heading
  font-family: $font
  margin-bottom: 7px
  .title
    @apply font-bold
    color: $cc-blue
    font-size: 36px
    line-height: 48px
  .subtitle
    @apply font-semibold
    color: $cc-green
    font-size: 22px
    line-height: 34px
</style>
